import { alterArrayItem } from './utils'

export function createInitialState(isFetching = false) {
  return {
    isFetching,
    items: [],
    hasMore: true,
    fetchedTimes: 0,
  }
}

export function onStartFetching(state) {
  if (state) {
    return {
      ...state,
      isFetching: true,
    }
  }
  return createInitialState(true)
}

export function onFetchSuccess(state, fetchedList, replace) {
  // * fetched empty array, i.e. no more items
  if (!fetchedList || !fetchedList.length) {
    return {
      ...state,
      items: replace ? [] : state.items,
      fetchedTimes: replace ? 1 : state.fetchedTimes + 1,
      hasMore: false,
      isFetching: false,
    }
  }

  if (replace) {
    return {
      ...state,
      items: fetchedList.map((fetchedItem, i) => ({
        ...(state.items?.[i] ?? {}),
        ...fetchedItem,
      })),
      fetchedTimes: 1,
      hasMore: true,
      isFetching: false,
    }
  }

  return {
    ...state,
    items: [...state.items, ...fetchedList],
    fetchedTimes: state.fetchedTimes + 1,
    isFetching: false,
  }
}

export function onFetchError(state) {
  return {
    ...state,
    hasMore: false,
    isFetching: false,
  }
}

export function updateSingleItem(state, fetchedItem, predicate, keys) {
  const { items } = state
  const index = items.findIndex(predicate)
  if (index < 0) {
    return state
  }
  const item = items[index]
  const newItem = keys
    ? {
        ...item,
        ...keys.reduce((prev, key) => {
          prev[key] = fetchedItem[key]
          return prev
        }, {}),
      }
    : {
        ...item,
        ...fetchedItem,
      }
  return {
    ...state,
    items: alterArrayItem(items, newItem, index),
  }
}
